import { createStore } from 'redux'
import authreducer from './MyReducers'

const store = createStore(authreducer)

export default store